export default {
    SET_CURRENCIES_STATE: 'setCurrenciesState',
    ADD_TARIFF_TYPE : 'addTariffType',
    DELETE_TARIFF : 'deleteTariff'
}